"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cometd = _interopRequireDefault(require("cometd"));

var _amb = _interopRequireDefault(require("./amb.ServerConnection"));

var _amb2 = _interopRequireDefault(require("./amb.Logger"));

var _amb3 = _interopRequireDefault(require("./amb.ChannelListener"));

var _amb4 = _interopRequireDefault(require("./amb.GraphQLSubscriptionExtension"));

var _amb5 = require("./amb.Properties");

var _amb6 = _interopRequireDefault(require("./amb.SessionExtension"));

var _amb7 = _interopRequireDefault(require("./amb.TokenManagementExtension"));

var _amb8 = _interopRequireDefault(require("./amb.CancelTransactionSender"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageClient = function MessageClient() {
  var cometd = new _cometd.default.CometD();
  cometd.registerTransport(_amb5.WEBSOCKET_TYPE_NAME, new _cometd.default.WebSocketTransport(), 0);
  cometd.registerTransport('long-polling', new _cometd.default.LongPollingTransport(), 1);
  cometd.unregisterTransport('callback-polling'); // Register extension needed for GraphQL subscriptions.

  var graphQLSubscriptionExtension = new _amb4.default();
  cometd.registerExtension('graphQLSubscription', graphQLSubscriptionExtension);
  var sessionExtension = new _amb6.default();
  cometd.registerExtension("sessionExtension", sessionExtension);
  var tokenManagementExtension = new _amb7.default();
  cometd.registerExtension(_amb5.TOKEN_MANAGEMENT_EXTENSION, tokenManagementExtension);
  var serverConnection = new _amb.default(cometd);
  var LOGGER = new _amb2.default('amb.MessageClient');
  var cancelTransactionSender = new _amb8.default();
  var connected = false;
  return {
    getServerConnection: function getServerConnection() {
      return serverConnection;
    },
    isLoggedIn: function isLoggedIn() {
      return serverConnection.isLoggedIn();
    },
    loginComplete: function loginComplete() {
      serverConnection.loginComplete();
    },
    reestablishSession: function reestablishSession() {
      serverConnection.reestablishSession();
    },

    /**
     * Server Connection
     */
    connect:
    /*void*/
    function connect() {
      if (connected) {
        LOGGER.addInfoMessage(">>> connection exists, request satisfied");
        return;
      }

      connected = true;
      serverConnection.connect();
    },
    reload:
    /*void*/
    function reload() {
      connected = false;
      serverConnection.reload();
    },
    abort:
    /*void*/
    function abort() {
      connected = false;
      serverConnection.abort();
    },
    disconnect:
    /*void*/
    function disconnect() {
      connected = false;
      serverConnection.disconnect();
    },
    // For unit testing.
    isConnected: function isConnected() {
      return connected;
    },

    /**
     * Connection Events
     */
    getConnectionEvents:
    /*Hash*/
    function getConnectionEvents() {
      return serverConnection.getEvents();
    },
    subscribeToEvent:
    /*Number*/
    function subscribeToEvent(
    /*String*/
    event,
    /*Function*/
    callback) {
      return serverConnection.subscribeToEvent(event, callback);
    },
    unsubscribeFromEvent:
    /*void*/
    function unsubscribeFromEvent(
    /*Number*/
    id) {
      serverConnection.unsubscribeFromEvent(id);
    },
    getConnectionState:
    /*String*/
    function getConnectionState() {
      return serverConnection.getConnectionState();
    },

    /**
     * Client info
     */
    getClientId:
    /*String*/
    function getClientId() {
      return cometd.getClientId();
    },

    /**
     * Channels
     */
    getChannel:
    /*amb.ChannelListener*/
    function getChannel(channelName, subscriptionConfig) {
      var _ref = subscriptionConfig || {},
          subscriptionCallback = _ref.subscriptionCallback,
          serializedGraphQLSubscription = _ref.serializedGraphQLSubscription,
          subscribeOptionsCallback = _ref.subscribeOptionsCallback;

      var channel = serverConnection.getChannel(channelName, subscribeOptionsCallback);

      if (graphQLSubscriptionExtension.isGraphQLChannel(channelName)) {
        if (serializedGraphQLSubscription) graphQLSubscriptionExtension.addGraphQLChannel(channelName, serializedGraphQLSubscription);else LOGGER.addErrorMessage("Serialized subscription not present for GraphQL channel " + channelName);
      }

      return new _amb3.default(channel, serverConnection, subscriptionCallback);
    },
    removeChannel: function removeChannel(channelName) {
      serverConnection.removeChannel(channelName);
      if (graphQLSubscriptionExtension.isGraphQLChannel(channelName)) graphQLSubscriptionExtension.removeGraphQLChannel(channelName);
    },
    getChannels: function getChannels() {
      return serverConnection.getChannels();
    },

    /**
     * Cancel transactions
     * @param cancelTransactionRequests: array of requests, which in the format: [{"nowUIInteraction": "interaction_2", "callback":function(message) { console.log(message);}}, {"nowUIInteraction": "interaction_3", "callback":function(message) { console.log(message);}}];
     */
    cancelTransaction: function cancelTransaction(cancelTransactionRequests) {
      cancelTransactionSender.cancelTransaction(cancelTransactionRequests, this);
    },
    extendSession: function extendSession() {
      sessionExtension.extendSession();
    },
    getTokenManagementExtension: function getTokenManagementExtension() {
      return tokenManagementExtension;
    },

    /**
     * Extensions
     */
    registerExtension:
    /*void*/
    function registerExtension(
    /*String*/
    extensionName,
    /*Object*/
    extension) {
      cometd.registerExtension(extensionName, extension);
    },
    unregisterExtension:
    /*void*/
    function unregisterExtension(
    /*String*/
    extensionName) {
      cometd.unregisterExtension(extensionName);
    },

    /**
     * Utility
     */

    /**
     * Executes messages in a batch.
     *
     * block is an anonymous function, containing a chain of messages to be posted
     * together, and executed in sequence
     *
     * Example:
     *        block = function() {
           * 			channel.subscribe();
           *			channel.publish({ user: 'Fred', message: 'Fred has joined the channel' });
           *		}
     */
    batch:
    /*void*/
    function batch(
    /*function(){...}*/
    block) {
      cometd.batch(block);
    }
  };
};

var _default = MessageClient;
exports.default = _default;